import { render } from "./QuizQuestionForm.vue?vue&type=template&id=bdfce74e"
import script from "./QuizQuestionForm.vue?vue&type=script&lang=js"
export * from "./QuizQuestionForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__